// extracted by mini-css-extract-plugin
module.exports = {"root":"_1HETs","menu":"Ufd3k","align-right":"_3cJli","alignRight":"_3cJli"};